import FadeUp from "./FadeUp";
import { CONTACT } from "../data/content";

export default function CTABanner() {
  return (
    <section className="bg-gradient-to-br from-brand to-brand-dark py-20 text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <FadeUp>
          <div className="flex flex-col items-center gap-8 text-center lg:flex-row lg:justify-between lg:text-left">
            <div>
              <p className="section-label justify-center text-white/80 lg:justify-start">
                ← Ready to Explore? →
              </p>
              <h2 className="font-heading text-3xl font-extrabold leading-tight sm:text-5xl">
                Discover The Best Places <br className="hidden sm:block" /> Across India
              </h2>
              <p className="mt-4 max-w-lg text-white/85">
                From sacred temples to misty hill stations, let JSR Travels plan
                your perfect journey with a chauffeur who knows the way.
              </p>
            </div>

            {/* Rotating badge + arrow */}
            <div className="relative grid h-44 w-44 shrink-0 place-items-center">
              <svg className="absolute inset-0 h-full w-full animate-spin-slow" viewBox="0 0 100 100">
                <defs>
                  <path
                    id="cta-circle"
                    d="M50,50 m-37,0 a37,37 0 1,1 74,0 a37,37 0 1,1 -74,0"
                  />
                </defs>
                <text className="fill-white/90 text-[8.5px] uppercase tracking-[0.25em]">
                  <textPath href="#cta-circle" xlinkHref="#cta-circle">
                    Book Now · 24/7 Support · JSR Travels ·
                  </textPath>
                </text>
              </svg>
              <a
                href={`https://wa.me/${CONTACT.wa}?text=Hi%20JSR%20Travels%2C%20I%20want%20to%20plan%20a%20trip`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Book your trip"
                className="grid h-20 w-20 place-items-center rounded-full bg-accent text-2xl text-white transition-transform hover:scale-105"
              >
                →
              </a>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
